import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82e0018a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute" }


    import Icon from '@/components/Icon/IndexIcon.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CloseButton',
  emits: ['close-box'],
  setup(__props, { emit }) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = () => emit('close-box')),
      class: "closeButton"
    }, [
      _createVNode(Icon, {
        name: "close",
        size: "12"
      })
    ])
  ]))
}
}

})